import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShare = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M12.5 35v40.659h75V35h-8.92v31.742H21.42V35z" }), /* @__PURE__ */ _jsx("path", { d: "M50 20 36.623 33.377h8.917v22.826h8.92V33.377h8.916z" })]
});
export default SvgShare;
